import React, { useContext, useEffect } from 'react'
import * as classes from './PageLoader.module.scss'
import anime from 'animejs'
import { FormContext } from '../../../context'
import IconLogoMini from '../../ui/Preloader/IconLogoMini'

export default function PageLoader() {
    const { setPageLoader, setAnimationStart } = useContext(FormContext)

    useEffect(() => {
        setTimeout(() => {
            setAnimationStart(true)

            const wrap = document.querySelector(`.${classes.Wrap}`)

            if (wrap) {
                const animation = anime({
                    targets: wrap,
                    duration: 750,
                    delay: 0,
                    easing: 'cubicBezier(.25, .1, .25, 1)',
                    opacity: [1, 0]
                })

                animation.finished.then(() => setPageLoader(false))
            } else {
                setPageLoader(false)
            }
        }, 1600)
    }, [])

    return (
        <div className={classes.PageLoader}>
            <div className={classes.Wrap}>
                <div className={classes.Logo}>
                    <IconLogoMini />
                </div>
            </div>
        </div>
    )
}
